import bfmapData from "@/assets/js/bfmap-data";
/* eslint-disable */
/**
 *@author  ahuan
 *@data 2023/10/25 10:43
 **/
let bfMap = {
    build: '', // 项目ID
    map: '', //地图初始化对象
    currentFloorId: '', // 当前楼层
    floorDataArr: '', // 当前项目楼层数据
    initMapFlag: false, //判断地图是否初始化完毕
    styleUrl: 'https://www.beefindtech.com:8443/gos/gosweb/style?build_id=', // 地图基础图层样式
    zoom: 0,
    /**
     * 初始化楼层控件
     */
    initFloor: function (build, f) {
        bfmapData.getFloorData(build, function (data) {
            if (data.zoom) {
                bfMap.zoom = data.zoom;
            } else {
                bfMap.zoom = 8;
            }
            // 动态生成楼层
            $('.floorUp').addClass('off');
            $('#loading').css('display', 'none');
            bfMap.floorDataArr = data.response;
            bfMap.remarks = data.remarks;
            if (data.response.length == 1) {
                $('.floorDown').addClass('off');
            }
            $('.scroll ul').html("")
            data.response.forEach((res, index) => {
                if (index == 0) {
                    $('.scroll ul').append("<li  class='active'><span>" + res.floorName + "</span></li>");
                    bfMap.currentFloorId = res.floorID;
                } else {
                    $('.scroll ul').append("<li ><span>" + res.floorName + "</span></li>");
                }
                /*if(bfMap.currentFloorId){
                    if(res.floorID === bfMap.currentFloorId){
                        $('.scroll ul').append("<li  class='active'><span>" + res.floorName + "</span></li>");
                    }else{
                        $('.scroll ul').append("<li ><span>" + res.floorName + "</span></li>");
                    }
                }else{
                    if (index == 0) {
                        $('.scroll ul').append("<li  class='active'><span>" + res.floorName + "</span></li>");
                        bfMap.currentFloorId = res.floorID;
                    } else {
                        $('.scroll ul').append("<li ><span>" + res.floorName + "</span></li>");
                    }
                }*/
            });
            if (f) {
                f()
            }
        });
    },
    createPopup:function (point,html) {
        return new mapboxgl.Popup()
            .setLngLat(point)
            .setHTML(html)
            .addTo(bfMap.map);
    },
    /**
     * 初始化地图
     */
    initMap: function (container, build, f) {
        bfMap.build = build;
        bfMap.map = new mapboxgl.Map({
            container: container,
            style: bfMap.styleUrl + build,
            center: [0, 0],
            zoom: 8,
            pitch: 0, // 0 -60
            bearing: 0,
            doubleClickZoom: false,
            hash: false,
            trackResize: true,
            scrollZoom: true,
        });
        bfMap.initFloor(build, function () {
            bfMap.initParking(f);
        });

    },

    /**
     * 初始化车位层
     */
    initParking: function (f) {
        bfMap.map.on('load', function () {
            bfMap.setMapCenter(bfMap.currentFloorId);
            bfMap.floorDataArr.forEach((res, index) => {
                var display = index == 0 ? 'visible' : 'none'; // 判断这个层是否显示默认只显示第一层
                var floorId = res.floorID;
                bfmapData.getPakingData(floorId, bfMap.build, function (res) {
                    if (res.result == 1) {
                        res.features.forEach(item => {
                            item.properties.color = "#ccc";
                            item.properties.pointX = item.properties.cpoint[0];
                            item.properties.pointY = item.properties.cpoint[1];
                        });
                        bfMap.crawParkingLayer(res, floorId + '-park-layer', floorId, display);
                        bfMap.crawParkingNumberLayer(res, floorId + '-park-point-layer', display, function () {
                            f();
                        });
                    }
                });
            });

        });
    },
    /**
     * 绘制车位层
     */
    crawParkingLayer: function (res, layerId, floorId, display) {
        if (bfMap.updateLayerData(layerId, res)) {
            bfMap.map.addSource(layerId, {
                type: 'geojson',
                data: res
            });
            bfMap.map.addLayer({
                'id': layerId,
                'type': 'fill',
                'source': layerId,
                'layout': {
                    'visibility': display,
                },
                'paint': {
                    'fill-antialias': true,
                    'fill-opacity': 1,
                    'fill-color': ['get', 'color'],
                    // 'fill-outline-color': '#000000',
                    'fill-translate': [0, 0],
                    'fill-translate-anchor': 'map',
                    // 'fill-pattern': 'car-15',
                }
            }, bfMap.map.getLayer(floorId + '-building-layer-2') ? floorId + '-building-layer-2' : '');
        }
        if (bfMap.updateLayerData(layerId + '-line', res)) {
            bfMap.map.addSource(layerId + '-line', {
                type: 'geojson',
                data: res
            });
            //车位边框
            bfMap.map.addLayer({
                'id': layerId + '-line',
                'type': 'line',
                'source': layerId + '-line',
                'layout': {
                    'line-cap': 'butt',
                    'line-join': 'miter',
                    'line-miter-limit': 2,
                    'line-round-limit': 1.05,
                    'visibility': display,
                },
                'paint': {
                    'line-opacity': 1,
                    'line-color': '#ffffff',
                    'line-translate': [0, 0],
                    'line-translate-anchor': 'map',
                    'line-width': 2,
                    'line-gap-width': 0,
                    'line-offset': 0,
                    'line-blur': 0,
                }
            }, bfMap.map.getLayer(floorId + '-building-layer-2') ? floorId + '-building-layer-2' : ''); //防止挡住建筑
        }
    },
    /**
     * 绘制线条
     */
    crawLineLayer: function (res, layerId, display, carLayerId) {
        if (bfMap.updateLayerData(layerId, res)) {
            bfMap.map.addSource(layerId, {
                type: 'geojson',
                data: res
            });
            bfMap.map.addLayer({
                'id': layerId,
                'type': 'line',
                'source': layerId,
                'layout': {
                    'line-cap': 'butt',
                    'line-join': 'miter',
                    'line-miter-limit': 2,
                    'line-round-limit': 1.05,
                    'visibility': display,
                },
                'paint': {
                    'line-opacity': 1,
                    'line-color': 'pink',
                    'line-translate': [0, 0],
                    'line-translate-anchor': 'map',
                    'line-width': 4,
                    'line-gap-width': 0,
                    'line-offset': 0,
                    'line-blur': 0,
                }
            }, carLayerId || '');
        }
    },
    /**
     * 绘制虚线
     */
    crawDottedLineLayer: function (res, layerId, display, carLayerId) {
        if (bfMap.updateLayerData(layerId, res)) {
            bfMap.map.addSource(layerId, {
                type: 'geojson',
                data: res
            });
            bfMap.map.addLayer({
                'id': layerId,
                'type': 'line',
                'source': layerId,
                'layout': {
                    'line-join': 'round',
                    'line-cap': 'round',
                    'visibility': display
                },
                'paint': {
                    'line-width': ['get', 'width'],
                    'line-color': ['get', 'color'],
                    'line-dasharray': [0.2, 1.5]
                }
            }, carLayerId || '');
        }
    },
    /**
     * 绘制圆
     */
    crawCircleLayer: function (res, layerId, display, carLayerId) {
        if (bfMap.updateLayerData(layerId, res)) {
            bfMap.map.addSource(layerId, {
                type: 'geojson',
                data: res
            });
            bfMap.map.addLayer({
                'id': layerId,
                'type': 'circle',
                'source': layerId,
                'layout': {
                    'visibility': display,
                },
                'paint': {
                    'circle-color': ['get', 'color'],
                    'circle-radius': ['get', 'radius'],
                    'circle-blur': 0,
                    'circle-stroke-width': ['get', 'borderWidth'],
                    'circle-stroke-color': ['get', 'borderColor'],
                }
            }, carLayerId || '');
        }
    },
    /**
     * 绘制文本层
     */
    crawTextLayer: function (res, layerId, display) {
        if (bfMap.updateLayerData(layerId, res)) {
            bfMap.map.addLayer({
                'id': layerId,
                'type': 'symbol',
                'source': {
                    'type': 'geojson',
                    'data': res
                },
                'layout': {
                    'symbol-placement': 'point',
                    'symbol-spacing': 250,
                    'symbol-avoid-edges': false,
                    'symbol-z-order': 'viewport-y',
                    'icon-allow-overlap': false,
                    'icon-ignore-placement': false,
                    'icon-optional': false,
                    'icon-rotation-alignment': 'auto',
                    'icon-size': 1,
                    'icon-text-fit': 'none',
                    'icon-text-fit-padding': [0, 0, 0, 0],
                    // 'icon-image': 'info-{inpointType}-m',
                    'icon-rotate': 0,
                    'icon-padding': 2,
                    'icon-keep-upright': false,
                    'icon-offset': [0, 0],
                    'icon-anchor': 'center',
                    'icon-pitch-alignment': 'auto',
                    'text-pitch-alignment': 'auto',
                    'text-rotation-alignment': 'auto',
                    'text-field': '{text}', //用大括号“{}”来引用属性中的字段
                    'text-font': ['msyh'],
                    'text-size': 12,
                    'text-max-width': 10,
                    'text-line-height': 1.2,
                    'text-letter-spacing': 0,
                    'text-justify': 'center',
                    'text-anchor': 'center',
                    'text-max-angle': 45,
                    'text-rotate': 0,
                    'text-padding': 2,
                    'text-keep-upright': true,
                    'text-transform': 'none',
                    'text-offset': [0, 0],
                    'text-allow-overlap': false,
                    'text-ignore-placement': false,
                    'text-optional': false,
                    'visibility': display
                },
                'paint': {
                    'icon-opacity': 1,
                    'icon-color': '#000000',
                    'icon-halo-color': 'rgba(0, 0, 0, 0)',
                    'icon-halo-width': 0,
                    'icon-halo-blur': 0,
                    'icon-translate': [0, 0],
                    'icon-translate-anchor': 'map',
                    'text-opacity': 1,
                    'text-color': ['get', 'textColor'],
                    'text-halo-color': 'rgba(255, 255, 255, 255)',
                    'text-halo-width': 2,
                    'text-halo-blur': 1,
                    'text-translate': [0, 0],
                    'text-translate-anchor': 'map',
                }
            })
        }
    },
    /**
     * 绘制文本层
     */
    crawParkingNumberLayer: function (res, layerId, display, f) {
        if (bfMap.updateLayerData(layerId, res)) {
            bfMap.map.addLayer({
                'id': layerId,
                'type': 'symbol',
                'source': {
                    'type': 'geojson',
                    'data': res
                },
                'layout': {
                    'symbol-placement': 'point',
                    'symbol-spacing': 250,
                    'symbol-avoid-edges': false,
                    'symbol-z-order': 'viewport-y',
                    'icon-allow-overlap': false,
                    'icon-ignore-placement': false,
                    'icon-optional': false,
                    'icon-rotation-alignment': 'auto',
                    'icon-size': 1,
                    'icon-text-fit': 'none',
                    'icon-text-fit-padding': [0, 0, 0, 0],
                    // 'icon-image': 'info-{inpointType}-m',
                    'icon-rotate': 0,
                    'icon-padding': 2,
                    'icon-keep-upright': false,
                    'icon-offset': [0, 0],
                    'icon-anchor': 'center',
                    'icon-pitch-alignment': 'auto',
                    'text-pitch-alignment': 'auto',
                    'text-rotation-alignment': 'auto',
                    'text-field': '{parknum}', //用大括号“{}”来引用属性中的字段
                    'text-font': ['msyh'],
                    'text-size': 12,
                    'text-max-width': 10,
                    'text-line-height': 1.2,
                    'text-letter-spacing': 0,
                    'text-justify': 'center',
                    'text-anchor': 'center',
                    'text-max-angle': 45,
                    'text-rotate': 0,
                    'text-padding': 2,
                    'text-keep-upright': true,
                    'text-transform': 'none',
                    'text-offset': [0, 0],
                    'text-allow-overlap': false,
                    'text-ignore-placement': false,
                    'text-optional': false,
                    'visibility': display
                },
                'paint': {
                    'icon-opacity': 1,
                    'icon-color': '#000000',
                    'icon-halo-color': 'rgba(0, 0, 0, 0)',
                    'icon-halo-width': 0,
                    'icon-halo-blur': 0,
                    'icon-translate': [0, 0],
                    'icon-translate-anchor': 'map',
                    'text-opacity': 1,
                    'text-color': ['get', 'textColor'],
                    'text-halo-color': 'rgba(255, 255, 255, 255)',
                    'text-halo-width': 2,
                    'text-halo-blur': 1,
                    'text-translate': [0, 0],
                    'text-translate-anchor': 'map',
                }
            });
            if (f) {
                if (!bfMap.initMapFlag) {
                    bfMap.initMapFlag = true;
                    f();
                }
            }
        }
    },
    /**
     * 绘制设备
     */
    crawDevLayer: function (layerId, data, display) {
        console.log(bfmapData.setGeojson(data))
        if (bfMap.updateLayerData(layerId, bfmapData.setGeojson(data))) {
            bfMap.map.addLayer({
                'id': layerId,
                'type': 'symbol',
                'source': {
                    'type': 'geojson',
                    'data': bfmapData.setGeojson(data)
                },
                'layout': {
                    'symbol-placement': 'point',
                    'symbol-spacing': 250,
                    'symbol-avoid-edges': false,
                    'symbol-z-order': 'viewport-y',
                    'icon-ignore-placement': false,
                    'icon-optional': false,
                    'icon-rotation-alignment': 'auto',
                    'icon-size': ['get', 'imgSize'],
                    'icon-text-fit': 'none',
                    'icon-text-fit-padding': [0, 0, 0, 0],
                    'icon-image': ['get', 'img'],
                    'icon-rotate': 0,
                    'icon-padding': 2,
                    'icon-keep-upright': false,
                    'icon-offset': [0, 0],
                    'icon-anchor': 'center',
                    'icon-pitch-alignment': 'auto',
                    'text-pitch-alignment': 'auto',
                    'text-rotation-alignment': 'auto',
                    'text-field': '{text}',
                    'text-font': ['msyh'],
                    'text-size': ['get', 'textSize'],
                    'text-max-width': 15,
                    'text-line-height': 1.2,
                    'text-letter-spacing': 0,
                    'text-justify': 'center',
                    'text-anchor': 'center',
                    'text-max-angle': 45,
                    'text-rotate': 0,
                    'text-padding': 2,
                    'text-keep-upright': true,
                    'text-transform': 'none',
                    'text-offset': [0, 0],
                    'text-ignore-placement': false,
                    'text-optional': false,
                    'text-allow-overlap': true,
                    'icon-allow-overlap': true,
                    'visibility': display
                },
                'paint': {
                    'icon-opacity': 1,
                    'icon-color': '#000000',
                    'icon-halo-color': 'rgba(0, 0, 0, 0)',
                    'icon-halo-width': 0,
                    'icon-halo-blur': 0,
                    'icon-translate': [0, 0],
                    'icon-translate-anchor': 'map',
                    'text-opacity': 1,
                    'text-color': ['get', 'textColor'],
                    'text-halo-color': 'rgba(255, 255, 255, 255)',
                    'text-halo-width': 2,
                    'text-halo-blur': 1,
                    'text-translate': [0, 0],
                    'text-translate-anchor': 'map',
                }
            });
        }
    },
    /**
     * 绘制分区色块图
     */
    heatMap: function (heatMap, layerId, display, carLayerId) {
        if (bfMap.updateLayerData(layerId, heatMap)) {
            bfMap.map.addSource(layerId, {
                type: 'geojson',
                data: heatMap
            });
            //把这个Geojson加进地图
            bfMap.map.addLayer({
                'id': layerId,
                'type': 'fill',
                'source': layerId,
                'layout': {
                    'visibility': display,
                },
                'paint': {
                    'fill-antialias': true,
                    'fill-opacity': ['case', ['boolean', ['feature-state', 'hover'], false], 1, 0.5], //mapbox表达式，
                    'fill-color': ['get', 'color'],
                    // 'fill-outline-color': '#000000',
                    'fill-translate': [0, 0],
                    'fill-translate-anchor': 'map',
                    // 'fill-pattern': 'car-15',
                }
            }, carLayerId || "");
        }
    },
    /**
     * 注册地图精灵图
     */
    loadImage: function (url, imgName) {
        bfMap.map.loadImage(url, function (error, image) {
            if (error) throw error;
            bfMap.map.addImage(imgName, image);
        });
    },
    /**
     * 绘制
     */
    /**
     *  设置当前楼层的车位状态
     */
    setCarState: function (currentFloorId, type, color) {
        if (bfMap.map.getSource(currentFloorId + '-park-layer')) {
            var newParkSource = bfMap.map.getSource(currentFloorId + '-park-layer')._data;
            newParkSource.features.forEach(item => {
                item.properties.carType = type;
                if (color) {
                    item.properties.color = color;
                }
            });
            bfMap.map.getSource(currentFloorId + '-park-layer').setData(newParkSource);
        }
    },
    /**
     * 恢复车位默认颜色
     */
    defaultCarColor: function (color, currentFloorId) {
        if (bfMap.map.getSource(currentFloorId + '-park-layer')) {
            var newParkSource = bfMap.map.getSource(currentFloorId + '-park-layer')._data;
            newParkSource.features.forEach(item => {
                item.properties.color = color;
            });
            bfMap.map.getSource(currentFloorId + '-park-layer').setData(newParkSource);
        }
    },
    /**
     * 改变多个车位状态颜色
     */
    setParkingColors: function (floorId, data, carType) {
        var currentParkSource = floorId + '-park-layer';
        var newParkSource = bfMap.map.getSource(currentParkSource)._data;
        var arr = newParkSource.features;
        for (let j = 0; j < data.length; j++) {
            for (let i = 0; i < arr.length; i++) {
                if (data[j].carpos_gid == arr[i].properties.parkId || data[j].parkId == arr[i].properties.parkId) {
                    arr[i].properties.color = data[j].color;
                    if (data[j].car_number) {
                        arr[i].properties.carPlate = data[j].car_number;
                        arr[i].properties.parkPic = data[j].car_picUrl;
                    }
                    if (data[j].value) {
                        arr[i].properties.value = data[j].value;
                    }
                    if (carType) {
                        arr[i].properties.carType = carType;
                    }

                    break;
                }
            }
        }
        bfMap.map.getSource(currentParkSource).setData(newParkSource);
    },
    /**
     * 按楼层获取车位的数据
     */
    getFloorParkingData: function (floorId) {
        return bfMap.map.getSource(floorId + '-park-layer')._data.features
    },
    /**
     * 地图居中
     */
    setMapCenter: function (flooId) {
        // console.log(flooId);
        // console.log(bfMap.floorDataArr);
        var center = bfMap.floorDataArr.filter(item => {
            return item.floorID == flooId;
        })[0].center;
        // console.log(center)
        // bfMap.map.flyTo({ center: center, animate: true });
        bfMap.map.setCenter(center);
        bfMap.map.setZoom(bfMap.zoom);

    },
    /**
     * 地图图层显示隐藏
     */
    mapLayerShowHide: function (layerId, display) {
        if (bfMap.map.getLayer(layerId)) {
            bfMap.map.setLayoutProperty(layerId, 'visibility', display)
        }
    },
    /**
     * 按楼层显示隐藏地图层
     */
    floorShowHide: function (floorId, f) {
        bfMap.map.style._order.forEach(item => {
            if (item != 'point-image') {
                item.split('-')[0] != floorId ? bfMap.mapLayerShowHide(item, 'none') : bfMap.mapLayerShowHide(item, 'visible');
            }
        });
        bfMap.currentFloorId = floorId;
        if (f) {
            f(floorId);
        }
    },
    /**
     * 动态切换楼层
     */
    dynamicChageFloor: function (floor_id, f) {
        var floorLength = bfMap.floorDataArr.length - 1;
        $('.scroll ul li').removeClass('active');
        $('.scroll ul li').each((index, item) => {
            if (bfMap.floorIdChange(floor_id) == $(item).find('span').text()) {
                $(item).addClass('active');
                if (index == 0) {
                    $('.floorUp').addClass('off');
                } else {
                    $('.floorUp').removeClass('off');
                }
                if (index == floorLength) {
                    $('.floorDown').addClass('off');
                } else {
                    $('.floorDown').removeClass('off');
                }
            }
        });
        bfMap.floorShowHide(floor_id, f);
    },
    /**
     * 切换楼层回调
     */
    changeFloor: function (f) {
        // 楼层切换
        $('.scroll ul').on('click', 'li', function () {
            var floorLength = bfMap.floorDataArr.length - 1;
            $(this).addClass('active').siblings('li').removeClass('active');
            var height = $(this).height();
            var flooId = bfMap.floorNameChange($(this).text());
            var index = bfMap.getFloorIndex(flooId);
            bfMap.floorShowHide(flooId, f);
            if (index > 2) {
                $('.scroll ul').scrollTop((index - 2) * height);
            } else {
                $('.scroll ul').scrollTop(0);
            }
            if (index == 0) {
                $('.floorUp').addClass('off');
            } else {
                $('.floorUp').removeClass('off');
            }
            if (index == floorLength) {
                $('.floorDown').addClass('off');
            } else {
                $('.floorDown').removeClass('off');
            }
            return false;
        });
        //往上切换楼层
        $('.floorUp').click(function () {
            var that = $('.scroll ul .active');
            var height = that.height();
            var index = bfMap.getFloorIndex(bfMap.currentFloorId);
            if (index > 0) {
                $('.floorDown').removeClass('off');
                var currentFloor = $('.scroll ul li').eq(index - 1);
                currentFloor.addClass('active').siblings('li').removeClass('active');
                $('.scroll ul').scrollTop((index - 2) * height);
                bfMap.floorShowHide(bfMap.floorDataArr[index - 1].floorID, f);
            }
            if (index - 1 == 0) {
                $('.floorUp').addClass('off');
            }
            return false;
        });
        // 往下切换楼层
        $('.floorDown').click(function () {
            var floorLength = bfMap.floorDataArr.length - 1;
            var that = $('.scroll ul .active');
            var height = that.height();
            var index = bfMap.getFloorIndex(bfMap.currentFloorId);
            if (index < floorLength) {
                $('.floorUp').removeClass('off');
                var currentFloor = $('.scroll ul li').eq(index + 1);
                currentFloor.addClass('active').siblings('li').removeClass('active');
                $('.scroll ul').scrollTop((index - 2) * height);
                bfMap.floorShowHide(bfMap.floorDataArr[index + 1].floorID, f);
            }
            if (index + 1 >= floorLength) {
                $('.floorDown').addClass('off');
            }
            return false;
        });

    },
    /**
     * 获取当前楼层在楼层数组的下标 为切换楼层用
     */
    getFloorIndex: function (floorId) {
        var number = 0;
        bfMap.floorDataArr.forEach((item, index) => {
            if (item.floorID == floorId) {
                number = index;
            }
        });
        return number;
    },
    /**
     * 楼层名转换楼层id
     */
    floorNameChange: function (floorName) {
        return bfMap.floorDataArr.filter(item => {
            return item.floorName == floorName;
        })[0].floorID;
    },
    /**
     * 楼层id转换楼层名
     */
    floorIdChange: function (floorId) {
        return bfMap.floorDataArr.filter(item => {
            return item.floorID == floorId;
        })[0].floorName;
    },
    /**
     * 地图事件车位回调
     */
    parkingon: function (type, f) {
        bfMap.map.on(type, function (e) {
            var feaure = bfMap.map.queryRenderedFeatures(e.point);
            if (!feaure[0]) {
                return;
            }
            var mapData = feaure.filter((item) => {
                return (
                    item.layer.id.split(bfMap.currentFloorId)[1] == "-park-layer"
                );
            });
            if (mapData.length > 0) {
                mapData[0].properties.lngLat = e.lngLat;
                f(mapData[0].properties);
            }
        });
    },
    on: function (type, f) {
        bfMap.map.on(type, function (e) {
            var features = bfMap.map.queryRenderedFeatures(e.point);
            if (f) {
                f({
                    lngLat: e.lngLat,
                    features: features
                });
            }
        })
    },
    /**
     * 绘制地图标记
     *type = 1 3857坐标系 type=2 4326坐标系 默认是4326
     */
    crawMarker: function (point, type, src, w, h) {
        var point = point;
        if (bfMap.mapMarker != undefined) {
            bfMap.mapMarker.remove();
        }
        if (type == 1) {
            point = bfMap.webMercator2LngLat(point);
        }
        var el = document.createElement('div');
        el.className = 'marker';
        el.style.backgroundImage =
            'url(' + src + ')';
        el.style.width = w || '100px';
        el.style.height = h || '33px';
        el.style.backgroundSize = '60%';
        el.style.backgroundRepeat = 'no-repeat';
        bfMap.mapMarker = new mapboxgl.Marker(el).setLngLat(point).addTo(bfMap.map);
    },
    /**
     * 判断这个层存不存在 存在就替换数据不添加
     */
    updateLayerData: function (layerId, newData) {
        var falg = true;
        if (bfMap.map.getLayer(layerId)) {
            bfMap.map.getSource(layerId).setData(newData);
            falg = false;
        }
        return falg;
    },
    /**
     3857坐标系转4326坐标系
     */
    webMercator2LngLat: function (point) {
        var lng = point[0] / 20037508.34 * 180;
        var lat = point[1] / 20037508.34 * 180;
        lat = 180 / Math.PI * (2 * Math.atan(Math.exp(lat * Math.PI / 180)) - Math.PI / 2);
        return [lng, lat];
    },
    /**
     4326坐标系转3857坐标系
     */
    webMercator2XY: function (point) {
        var x = point[0] * 20037508.34 / 180;
        var y = point[1] * 20037508.34 / 180;
        return [x, y];
    },
}
export default bfMap;
